import axios from '@/libs/api.request'
var qs = require('qs')
    // 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/teacher-video/video-list',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/teacher-video/video-shelf',
        data,
        method: 'post'
    })
};